import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import {
    addFromColumn,
    copyObjectArray,
    toCurrency,
    sortCurrency
} from '../shared/functions';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {getPriceFromLocation} from '../shared/reportFunctions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import InventorySummaryIcon from 'material-ui/svg-icons/action/assignment';
import Config from '../messages';
import CircularProgress from "material-ui/CircularProgress";

/**
 * Inventory Log Report class for retrieving and displaying table Summary
 *
 */
class InventoryLogReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inventoryList: [],
            inventoryTotalsList: [],
            inventoryTotalsListFinished: false,
            message: null,
            priceList: [],
            reportName: 'Inventory Log',
            selectedZeroDay: null,
            summaryComplete: false,
            summaryList: [],
            tableData: [],
            tableHeaders: [
                {label: 'Product ID', key: 'productId'},
                {label: 'Description', key: 'description'},
                {label: 'Category', key: 'categoryName'},
                {label: 'Received', key: 'totalReceived'},
                {label: 'Sold', key: 'totalSold'},
                {label: 'Returns + Transfers + Adjustments', key: 'totalRTA'},
                {label: 'Incoming Inventory Quantity', key: 'totalIncoming'},
                {label: 'Remaining', key: 'totalRemaining'},
                {label: 'Sell Price', key: 'sellPrice'},
                {label: '$ Amount in Location', key: 'amountInLocation'},
                {label: '$ Amount of Incoming Inventory', key: 'amountIncoming'}
            ],
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchDefaultPrices(this.props.location.productType);
        this.fetchInventoryByZeroDay(this.props.zeroDay);
        this.fetchIncomingTotals(this.props.location.id);
    }

    componentWillReceiveProps(nextProps) {
        let clearTable = false;
        if (
            nextProps.location.id !== this.props.location.id ||
            nextProps.location.productType !== this.props.location.productType
        ) {
            clearTable = true;
            this.fetchDefaultPrices(nextProps.location.productType);
            this.fetchIncomingTotals(nextProps.location.id);
        }
        if (nextProps.zeroDay !== this.props.zeroDay) {
            clearTable = true;
            this.fetchInventoryByZeroDay(nextProps.zeroDay);
        }
        if (clearTable) {
            this.setState({
                summaryList: [],
                tableData: [],
                summaryComplete: false
            });
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get Prices for selected Location's Product Type
     *
     * @param productType
     */
    fetchDefaultPrices(productType) {
        // Assemble the URI
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: 'product_id', order: 'ASC'},
            product_type: productType
        };
        const resource = reportsResources.DefaultPricesByProductType.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                const priceList = result.data.payload;
                this.setState({
                        priceList: priceList
                    },
                    () => this.generateSummary(null, priceList, null)
                );
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + ' Default Prices.';
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                    priceList: []
                }, () => {
                    this.generateSummary(null, [], null);
                    if (typeof this.props.onError === 'function') {
                        this.props.onError(message);
                    }
                }
            );
        });
    }

    /**
     * Get Inventory for selected Zero Day (for Inventory Summary)
     *
     * @param zeroDay
     */
    fetchInventoryByZeroDay(zeroDay) {
        // Assemble the URI
        const params = {
            filter: {},
            location_id: this.props.location.id.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: "type", order: "ASC"},
            zero_day: zeroDay
        };
        const resource = reportsResources.InventoryByZeroDay.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                this.processInventoryByZeroDayData(zeroDay, result.data.payload);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + ' inventory for ' + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                    inventoryList: [],
                    selectedZeroDay: zeroDay,
                    summaryList: [],
                    tableData: [],
                    summaryComplete: false
                }, () => {
                    this.generateSummary([], null, null);
                    if (typeof this.props.onError === 'function') {
                        this.props.onError(message);
                    }
                }
            );
        });
    }

    fetchIncomingTotals(locationId) {
        const params = {
            filter: {},
            location_id: this.props.location.id.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: 'product', order: 'ASC'}
        };
        const resource = reportsResources.InventoryIncomingItemTotals.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                this.processInventoryIncomingTotalsData(result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
            } else {
                console.log('Error', error.message);
            }
        });

    }

    /* Data Processing ------------------------------ */

    /**
     * Store Inventory by Zero Day results (for Inventory Summary)
     *
     * @param zeroDay
     * @param list
     */
    processInventoryByZeroDayData(zeroDay, list) {
        const length = list.length;
        if (list && length > 0 && typeof list === 'object') {
            this.setState({
                inventoryList: list,
                selectedZeroDay: zeroDay
            }, () => {
                this.generateSummary(list, null, null);
            });
        } else {
            this.setState({
                    inventoryList: [],
                    selectedZeroDay: zeroDay,
                    summaryList: [],
                    tableData: [],
                    summaryComplete: true
                },
                () => this.props.onSummaryComplete(true)
            );
        }
    }

    processInventoryIncomingTotalsData(list) {
        const length = list.length;
        if (list && length > 0 && typeof list === 'object') {
            this.setState({
                inventoryTotalsList: list,
                inventoryTotalsListFinished: true
            }, () => {
                this.generateSummary(null, null, list);
            });
        } else {
            this.setState({
                inventoryTotalsList: [],
                inventoryTotalsListFinished: true
            }, () => {
                this.generateSummary(null, null, []);
            });
        }
    }

    /* Table Building ------------------------------ */

    /**
     * Assemble values for Inventory Summary table
     *
     * @param iList
     * @param pList
     * @param tList
     */
    generateSummary(iList, pList, tList) {

        // Create arrays for existing Inventory, incoming Inventory, and Prices
        let invList = (iList) ? copyObjectArray(iList) : copyObjectArray(this.state.inventoryList);
        let totalsList = (tList) ? copyObjectArray(tList) : copyObjectArray(this.state.inventoryTotalsList);
        let priceList = (pList) ? copyObjectArray(pList) : copyObjectArray(this.state.priceList);

        let summaryList = [];
        let inventoryProcessed = false;
        let totalsProcessed = false;

        if (typeof iList === 'object' && priceList.length > 0) {
            // Cycle through existing Inventory List for values
            for (let i = 0; i < invList.length; i++) {
                const invItem = invList[i];
                if (invItem) {
                    // Create or update an Inventory Table Row item
                    const type = invItem.type;

                    // Populate row
                    let invIn = parseInt(invItem.inv_in, 10);
                    let invOut = parseInt(invItem.inv_out, 10);
                    let invInOut = invIn - invOut;
                    let productId = invItem.product.toString();
                    let categoryName = '';
                    let categoryId = '';
                    let totalIncoming = 0;
                    let totalReceived = 0;
                    let totalSold = 0;
                    let totalRTA = 0;
                    let rtaReturns = 0;
                    let rtaTransfers = 0;
                    let rtaAdjustments = 0;
                    let totalRemaining = 0;
                    let sellPrice = '0.00';
                    let amountInLocation = '0.00';
                    let amountIncoming = '0.00';

                    const invIdx = summaryList.findIndex(i => i.productId.toString() === productId);
                    if (invIdx === -1) {

                        // If this Product ID is not in the list, add it
                        totalReceived = (type === 'receive') ? invInOut : 0;
                        totalSold = (type === 'sale') ? invOut : 0;
                        rtaReturns = (type === 'return') ? invIn : 0;
                        rtaTransfers = (type === 'transfer') ? invInOut : 0;
                        rtaAdjustments = (type === 'admin_adjustment') ? invInOut : 0;
                        totalRTA = rtaReturns + rtaTransfers + rtaAdjustments;
                        totalRemaining = totalReceived - totalSold + totalRTA;
                        amountInLocation = '0.00';

                        // Retrieve values from Prices list to calculate columns (category, sell price)
                        let priceItem = null;
                        let priceIdx = priceList.findIndex(p => p.product_id.toString() === productId);
                        if (priceIdx !== -1) {
                            priceItem = priceList[priceIdx];
                            // Populate Category data
                            categoryId = priceItem.category_id;
                            categoryName = priceItem.category;
                            if (priceItem.price) {
                                // Extract the desired price for Sell Price column
                                let price = getPriceFromLocation(this.props.location, priceItem.price);
                                sellPrice = toCurrency(price);
                                // Calculate $ Amount in Location (Remaining * Sell Price)
                                let amountRemaining = (price * totalRemaining);
                                // Display the amount if it is a positive dollar amount
                                amountInLocation = (amountRemaining > 0) ? toCurrency(amountRemaining) : '0.00';
                            }
                        }

                        // Retrieve values from Totals list to calculate columns (totalIncoming, amountIncoming)
                        const totalsIdx = totalsList.findIndex(p => p.product.toString() === productId);
                        if (totalsIdx !== -1) {
                            let totalsItem = totalsList[totalsIdx];
                            // Populate Incoming Inventory totals and amount
                            if (totalsItem.qty) {
                                totalIncoming = (totalsItem.qty) ? totalsItem.qty : 0;
                                if (priceItem && priceItem.price) {
                                    // Extract the desired price for Sell Price column
                                    let price = getPriceFromLocation(this.props.location, priceItem.price);
                                    sellPrice = toCurrency(price);
                                    // Calculate $ Amount Incoming (Remaining * Sell Price)
                                    let amountIncomingPrice = (price * totalIncoming);
                                    amountIncoming = (amountIncomingPrice > 0) ? toCurrency(amountIncomingPrice) : '0.00';
                                }
                            }
                        }

                        // Assemble inventory row
                        let summaryRow = {
                            categoryId: categoryId,
                            categoryName: categoryName,
                            description: invItem.product_name,
                            invIn: invIn,
                            invOut: invOut,
                            productId: productId,
                            sellPrice: sellPrice,
                            totalIncoming: totalIncoming,
                            totalReceived: totalReceived,
                            totalSold: totalSold,
                            totalRTA: totalRTA,
                            rtaReturns: rtaReturns,
                            rtaTransfers: rtaTransfers,
                            rtaAdjustments: rtaAdjustments,
                            totalRemaining: totalRemaining,
                            amountIncoming: amountIncoming,
                            amountInLocation: amountInLocation,
                            type: type,
                        };
                        summaryList.push(summaryRow);

                    } else {

                        // If a row with this Product ID is already in the list, update its totals
                        const existingRow = summaryList[invIdx];
                        switch (type) {
                            case 'admin_adjustment':
                                existingRow.rtaAdjustments += invInOut;
                                break;
                            case 'receive':
                                existingRow.totalReceived += invInOut;
                                break;
                            case 'return':
                                existingRow.rtaReturns += invIn;
                                break;
                            case 'sale':
                                existingRow.totalSold += invOut;
                                break;
                            case 'transfer':
                                existingRow.rtaTransfers += invInOut;
                                break;
                            default:
                                break;
                        }

                        // Update this row's columns
                        existingRow.totalRTA = existingRow.rtaReturns + existingRow.rtaTransfers + existingRow.rtaAdjustments;
                        existingRow.totalRemaining = existingRow.totalReceived - existingRow.totalSold + existingRow.totalRTA;
                        let amountRemaining = (existingRow.sellPrice * existingRow.totalRemaining);
                        // Update the Amount remaining if it is a positive dollar amount
                        existingRow.amountInLocation = (amountRemaining > 0) ? toCurrency(amountRemaining) : '0.00';
                    }
                }
            }
            inventoryProcessed = true;
        }

        if (typeof tList === 'object' && priceList.length > 0) {
            // Cycle through incoming Inventory totals for values
            for (let i = 0; i < totalsList.length; i++) {
                const tItem = totalsList[i];
                if (tItem) {
                    const tIdx = summaryList.findIndex(i => i.productId.toString() === tItem.product);
                    if (tIdx === -1) {

                        // If this incoming Product is not yet in the list, add it
                        let invIn = 0;
                        let invOut = 0;
                        let productId = tItem.product.toString();
                        let categoryName = tItem.category_name;
                        let categoryId = '';
                        let totalIncoming = tItem.qty;
                        let totalReceived = 0;
                        let totalSold = 0;
                        let totalRTA = 0;
                        let rtaReturns = 0;
                        let rtaTransfers = 0;
                        let rtaAdjustments = 0;
                        let totalRemaining = 0;
                        let sellPrice = '0.00';
                        let amountInLocation = '0.00';
                        let amountIncoming = '0.00';

                        // Retrieve values from Prices list to calculate columns (category, sell price)
                        let priceItem = null;
                        let priceIdx = priceList.findIndex(p => p.product_id.toString() === productId);
                        if (priceIdx !== -1) {
                            priceItem = priceList[priceIdx];
                            // Populate Category data
                            categoryId = priceItem.category_id;
                            categoryName = priceItem.category;
                            if (priceItem.price) {
                                // Extract the desired price for Sell Price column
                                let price = getPriceFromLocation(this.props.location, priceItem.price);
                                sellPrice = toCurrency(price);
                                // Calculate $ Amount Incoming (Incoming * Sell Price)
                                let allIncoming = (price * totalIncoming);
                                // Display the amount if it is a positive dollar amount
                                amountIncoming = (allIncoming > 0) ? toCurrency(allIncoming) : '0.00';
                            }
                        }

                        // Assemble the incoming inventory row
                        let summaryRow = {
                            categoryId: categoryId,
                            categoryName: categoryName,
                            description: tItem.product_name,
                            invIn: invIn,
                            invOut: invOut,
                            productId: productId,
                            sellPrice: sellPrice,
                            totalIncoming: totalIncoming,
                            totalReceived: totalReceived,
                            totalSold: totalSold,
                            totalRTA: totalRTA,
                            rtaReturns: rtaReturns,
                            rtaTransfers: rtaTransfers,
                            rtaAdjustments: rtaAdjustments,
                            totalRemaining: totalRemaining,
                            amountIncoming: amountIncoming,
                            amountInLocation: amountInLocation,
                            type: '',
                        };
                        summaryList.push(summaryRow);
                    }
                }
            }
            totalsProcessed = true;
        }

        if (inventoryProcessed && totalsProcessed) {
            // Finalize Inventory Summary Table
            this.setState({
                    summaryList: summaryList,
                    tableData: summaryList,
                    summaryComplete: true
                },
                () => this.props.onSummaryComplete(true)
            );
        }
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                tableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            location,
            system,
            zeroDay
        } = this.props;

        const {
            summaryList,
            summaryComplete,
            tableData,
            tableHeaders,
            inventoryTotalsListFinished
        } = this.state;

        const defaultSort = setDefaultTableSort('productId');

        // ReactTable headers, columns and footer totals for Inventory Log
        const columns = [
            {
                Header: 'Products',
                columns: [
                    {
                        Header: 'Product ID',
                        accessor: 'productId',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        Footer: (<span style={tableStyles.footer}>&nbsp;</span>)
                    },
                    {
                        Header: 'Description',
                        accessor: 'description',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        Footer: (<span style={tableStyles.footer}>&nbsp;</span>)
                    },
                    {
                        Header: 'Category',
                        accessor: 'categoryName',
                        headerClassName: 'th-min-110',
                        style: tableStyles.tdMin,
                        headerStyle: tableStyles.thLast,
                        Footer: (<span style={tableStyles.footer}>Totals:</span>)
                    }
                ],
                headerClassName: 'th-min-330',
                style: tableStyles.thGroupMin
            },
            {
                Header: 'Customer Interactions',
                columns: [
                    {
                        Header: 'Received',
                        accessor: 'totalReceived',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(tableData, 'totalReceived')}
                            </span>
                        )
                    },
                    {
                        Header: 'Sold',
                        accessor: 'totalSold',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(tableData, 'totalSold')}
                            </span>
                        )
                    },
                    {
                        Header: 'Total Returns, Transfers, & Adjustments',
                        accessor: 'totalRTA',
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(tableData, 'totalRTA')}
                            </span>
                        )
                    }
                ]
            },
            {
                Header: 'Inventory',
                columns: [
                    {
                        Header: 'Incoming Inventory Quantity',
                        accessor: 'totalIncoming',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(tableData, 'totalIncoming')}
                            </span>
                        )
                    },
                    {
                        Header: 'Remaining',
                        accessor: 'totalRemaining',
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(tableData, 'totalRemaining')}
                            </span>
                        )
                    },
                    {
                        Header: 'Sell Price',
                        accessor: 'sellPrice',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (<span style={tableStyles.footer}>&nbsp;</span>)
                    },
                    {
                        Header: '$ Amount in Location',
                        accessor: 'amountInLocation',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(tableData, 'amountInLocation'))}
                            </span>
                        )
                    },
                    {
                        Header: '$ Amount of Incoming Inventory',
                        accessor: 'amountIncoming',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(tableData, 'amountIncoming'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                    <div className="reports-table-container">
                        {!inventoryTotalsListFinished &&
                            <div className="loader-container">
                                <h4>Generating Inventory Totals...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                        }
                        {/* Table Header: Inventory Summary */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container report-header-button-container">
                                {/* Export Inventory Summary */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={commonStyles.headerButton}
                                >
                                    <ExportIcon style={commonStyles.headerButtonIcon}/>
                                    <CSVLink
                                        data={tableData}
                                        headers={tableHeaders}
                                        filename={'Inventory-Log-Summary-' + system + '-' + location.id + '-' + zeroDay + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={commonStyles.headerButtonLink}
                                    >
                                        Export Inventory Summary
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <InventorySummaryIcon style={commonStyles.summaryIcon}/>
                                <span>Inventory Summary</span>
                            </h3>
                        </div>

                        {/* Table: Inventory Summary */}
                        {summaryList.length > 0 &&
                            <ReactTable
                                key="table-inventory-log-summary"
                                data={summaryList}
                                columns={columns}
                                defaultPageSize={1000}
                                defaultSorted={defaultSort}
                                filterable
                                defaultFilterMethod={filterCaseInsensitive}
                                onSortedChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                                onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                                ref={(r) => this.reactTable = r}
                                showPagination={false}
                                resizable={false}
                                minRows={1}
                                className="-striped summary-table"
                            />
                        }
                        {summaryList.length === 0 &&
                            <p>No Inventory for Location {location.id}.</p>
                        }
                    </div>
                }
            </div>
        )
    }
}

InventoryLogReport.propTypes = {
    addField: PropTypes.bool,
    location: PropTypes.object.isRequired,
    onDisplayMessage: PropTypes.func,
    onError: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    system: PropTypes.string,
    zeroDay: PropTypes.string.isRequired
};

InventoryLogReport.defaultProps = {
    addField: true,
    location: {
        dbaPriceLevel: null,
        id: null,
        name: null,
        priceLevel: null,
        productType: null
    },
    zeroDay: null
};

const enhance = compose(
    connect()
);

export default enhance(InventoryLogReport);



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryLogReport.js